import gql from 'graphql-tag';

export const fields = `
    name
    potentialIssues {
        id
        name
    }
    
    chartVariables {
        id
        displayName
        variableName
    }
    
    createdAt
    updatedAt
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateEngineModels (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateEngineModels (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetEngineModels (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetEngineModels (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindEngineModelById (
        $id: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindEngineModelById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdWithRelationsQuery = gql`
    query DigitaiFindEngineModelByIdWithRelations (
        $id: ID
        $constraint: QueryStatement
        $queryPaginateEngineModelsPotentialIssues: QueryStatement
        $constraintPaginateEngineModelsPotentialIssues: QueryStatement
        $queryPaginatePotentialIssues: QueryStatement
        $constraintPaginatePotentialIssues: QueryStatement
        $queryGetEngineModelsPotentialIssues: QueryStatement
        $constraintGetEngineModelsPotentialIssues: QueryStatement
        $queryPaginateEngineModelsChartVariables: QueryStatement
        $constraintPaginateEngineModelsChartVariables: QueryStatement
        $queryPaginateChartVariables: QueryStatement
        $constraintPaginateChartVariables: QueryStatement
        $queryGetEngineModelsChartVariables: QueryStatement
        $constraintGetEngineModelsChartVariables: QueryStatement
    ) {
        object: digitaiFindEngineModelById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
        digitaiPaginateEngineModelsPotentialIssues (
            query: $queryPaginateEngineModelsPotentialIssues
            constraint: $constraintPaginateEngineModelsPotentialIssues
        ) {
            total
            rows
            count
        }
        digitaiPaginatePotentialIssues (
            query: $queryPaginatePotentialIssues
            constraint: $constraintPaginatePotentialIssues
        ) {
            total
            rows
            count
        }
        digitaiGetEngineModelsPotentialIssues (
            query: $queryGetEngineModelsPotentialIssues
            constraint: $constraintGetEngineModelsPotentialIssues
        ) {
            potentialIssueId
        }
        digitaiPaginateEngineModelsChartVariables (
            query: $queryPaginateEngineModelsChartVariables
            constraint: $constraintPaginateEngineModelsChartVariables
        ) {
            total
            rows
            count
        }
        digitaiPaginateChartVariables (
            query: $queryPaginateChartVariables
            constraint: $constraintPaginateChartVariables
        ) {
            total
            rows
            count
        }
        digitaiGetEngineModelsChartVariables (
            query: $queryGetEngineModelsChartVariables
            constraint: $constraintGetEngineModelsChartVariables
        ) {
            chartVariableId
        }
        ${relationsFields}
    }
`;

export const findQuery = gql`
    query DigitaiFindEngineModel (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindEngineModel (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateEngineModel (
        $payload: DigitaiCreateEngineModelInput!
    ) {
        digitaiCreateEngineModel (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateEngineModels (
        $payload: [DigitaiCreateEngineModelInput]!
    ) {
        digitaiCreateEngineModels (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateEngineModelById (
        $payload: DigitaiUpdateEngineModelByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateEngineModelById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateEngineModels (
        $payload: DigitaiUpdateEngineModelsInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateEngineModels (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteEngineModelById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteEngineModelById (
            id: $id
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteEngineModels (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteEngineModels (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
